import { AbstractControl, ValidatorFn } from '@angular/forms';

export function maxSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    /**
     * Get the base64 String of the photo and calculate the filesize
     */
    if (control && control.value) {
      const base64String = control.value;
      const [fileFormat, fileData] = base64String.includes(',')
        ? base64String.split(',')
        : [, base64String];
      const stringLength = fileData.length;
      const sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
      const sizeInMb = sizeInBytes / (1000 * 1000);
      if (sizeInMb >= maxSize) {
        return { maxSize: true };
      }
      return null;
    }

    return null;
  };
}

export function allowedExtensionValidator(
  allowedExtension: string[]
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    /**
     * Get the base64 String of the photo and compare the mime type with allowedExtensions
     */
    if (control && control.value) {
      const inputValue = control.value;
      const isAcceptedExt: boolean = allowedExtension.some(item =>
        inputValue.includes(item)
      );
      return !isAcceptedExt ? { allowedExtension: true } : null;
    }

    return null;
  };
}
